module.exports = __webpack_public_path__ + "media/images/favicon/mstile-310x150-97cfcac41602f48e1b2f698677712f27.png";